import { useEffect, useState } from 'react';
import { ReactComponent as StarIcon } from '$icons/uncolored/star.svg';
import { ReactComponent as FilledStarIcon } from '$icons/uncolored/filledStar.svg';
import { useGetRatingEmployerQuery } from '$store/modules/ratings';

interface Props {
  additionalVideoId: number;
  videoRating: number;
  setVideoRating: (ind: number) => void;
}

const SPKEmployerCandidateVideosRate = ({
  additionalVideoId,
  videoRating,
  setVideoRating,
}: Props) => {
  const { data: employerRate } = useGetRatingEmployerQuery({
    data: {
      additionalVideoId,
    },
  });

  const [hoverIndex, setHoverIndex] = useState(videoRating || -1);

  useEffect(() => {
    if (employerRate) setHoverIndex(employerRate.Rating - 1);
  }, [employerRate, setHoverIndex]);

  useEffect(() => {
    setHoverIndex(videoRating);
  }, [videoRating]);

  const stars = Array.from({ length: 5 }, (item, index) => {
    if (index <= hoverIndex) {
      return (
        <FilledStarIcon
          key={index}
          width="24px"
          height="24px"
          onMouseEnter={() => setHoverIndex(index)}
          onClick={() => setVideoRating(index)}
          className="fill-spk-brightBlue"
        />
      );
    }

    return (
      <StarIcon
        key={index}
        width="24px"
        height="24px"
        onMouseEnter={() => setHoverIndex(index)}
        onClick={() => setVideoRating(index)}
        className="fill-spk-brightBlue"
      />
    );
  });
  return (
    <div
      className="flex flex-row gap-2"
      onMouseLeave={() => setHoverIndex(videoRating)}
    >
      {stars}
    </div>
  );
};

SPKEmployerCandidateVideosRate.defaultProps = {
  candidateId: undefined,
};

export default SPKEmployerCandidateVideosRate;
